import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { getKeyByValue } from "./helper";
interface SlideProps {
  radius: any;
  onChange: (e: any) => void;
  onAfterChange?: (e: any) => void;
  marks?: any;
  className?: string;
}

const RadiusWaypoints = ({
  radius,
  onChange,
  onAfterChange,
  marks,
  className,
}: SlideProps) => {
  return (
    <div className={`group relative ${className}`}>
      <div className="w-fit absolute inset-x-0 bottom-full mx-auto items-center justify-center opacity-0 mb-4 group-hover:opacity-100 md:flex hover-anime hidden">
        <div className="bg-white rounded-xl p-3 w-[9.063rem] flex flex-col justify-center items-center space-y-2">
          <p className="text-tiny-none text-neutral-600 text-center">
            Move slider to resize your radius
          </p>
          <div className="font-bold text-small-tight text-neutral-900">
            {radius.miles}miles
          </div>
        </div>
      </div>

      <div className="bg-white p-2 px-5 w-full shadow-lv3 rounded-xl relative h-[3.75rem]">
        {radius.miles > 0 && (
          <Slider
            min={1}
            max={Object.keys(marks).length}
            defaultValue={Number(getKeyByValue(marks, radius.miles.toString()))}
            value={Number(getKeyByValue(marks, radius.miles.toString()))}
            onChange={(e) => {
              const cek = marks[e.toString()];
              if (cek) {
                onChange?.(Number(cek));
              }
            }}
            onAfterChange={(e) => {
              const cek = marks[e.toString()];
              if (cek) {
                onAfterChange?.(Number(cek));
              }
            }}
            marks={marks}
            step={null}
            railStyle={{
              backgroundColor: "#e2e8f0",
            }}
            trackStyle={{
              backgroundColor: "#3366FF",
            }}
            handleStyle={{
              width: "1.25rem",
              height: "1.25rem",
              border: "solid 1px #3366FF",
              opacity: "1",
              backgroundColor: "#3366FF",
              marginTop: "-8px",
            }}
            dotStyle={{
              border: "solid 1px #CBD5E0",
              backgroundColor: "#CBD5E0",
              width: "1.25rem",
              height: "1.25rem",
              bottom: "-8px",
            }}
            activeDotStyle={{
              border: "solid 1px #3366FF",
              backgroundColor: "#3366FF",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default RadiusWaypoints;
